import { parseApproximateLocation } from 'shared/library/approximate-location';
import { useLocation } from 'shared/library/use-location';
import { requestApproximateLocation } from 'shared/library/use-location/location-service';
import useLocationStore from 'shared/state/location';
import {
  fetchApproximateLocation,
  type FetchApproximateLocationOptions,
} from './use-location/fetch-approximate-location.web';

export { fetchApproximateLocation };

export function getApproximateLocation(options?: FetchApproximateLocationOptions) {
  return requestApproximateLocation(() => fetchApproximateLocation(options));
}

export function resetApproximateLocationCacheForTests() {
  useLocationStore.getState().reset();
}

export function useApproximateLocation(preferredLocation?: unknown, fallbackLocation?: unknown) {
  const preferred = parseApproximateLocation(preferredLocation);
  const fallback = parseApproximateLocation(fallbackLocation);
  const { location, ready } = useLocation({ approximate: preferred === null });
  return { location: preferred ?? location ?? fallback, ready: preferred !== null || ready };
}
